module.exports = __webpack_public_path__ + "img/uganda.a22fc0f.webp";